import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import BrandJoinListWrap from '../../views/brand/join/BrandJoinListWrap';
import { brandActions } from '../../store/modules/brand';
import {
  BRAND_JOIN_LIST_FILTER_OPTION_MODEL,
  BRAND_JOIN_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/brand/models';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { message } from 'antd';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';

class BrandJoinListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { location } = this.props;
    /**
     *  페이지에 처음 접근하는 것이 아닐 경우, 이전 검색조건으로 검색한다.
     */
    if (location.state) {
      this.getList({
        filterOption: location.state.filterOption,
        pagination: location.state.pagination,
        sortOption: location.state.sortOption,
      });
    } else {
      /**
       *  페이지에 처음 접근하면 초기화된 검색 조건으로 검색한다.
       */
      this.getList({
        filterOption: BRAND_JOIN_LIST_FILTER_OPTION_MODEL,
        sortOption: BRAND_JOIN_LIST_SORT_OPTION_MODEL,
        pagination: LIST_PAGINATION_MODEL,
      });
    }
  };

  getList = (data) => {
    const { getBrandJoinList, brandJoinList, history } = this.props;
    const { filterOption, sortOption, pagination } = brandJoinList;

    /**
     *  서버에 요청
     */
    getBrandJoinList({
      filterOption,
      sortOption,
      pagination,
      ...data,
    });

    /**
     *  history 에 검색조건을 저장한다
     */
    history.replace({
      ...history.location,
      state: {
        filterOption,
        sortOption,
        pagination,
        ...data,
      },
    });
  };

  /**
   * 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getBrandJoinExcelDownload, pageName, brandJoinList } = this.props;

    if (!brandJoinList || !brandJoinList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getBrandJoinExcelDownload({
      filterOption: brandJoinList.filterOption,
      sortOption: brandJoinList.sortOption,
      brandJoinPageName: pageName,
    });
  };

  render() {
    const { brandJoinList } = this.props;

    return (
      <BrandJoinListWrap
        brandJoinList={brandJoinList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    brandJoinList: state.brand.brandJoinList,
  };
};

const mapDispatchToProps = {
  setData: brandActions.setData,
  getBrandJoinList: brandActions.getBrandJoinList,
  getBrandJoinExcelDownload: brandActions.getBrandJoinExcelDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BrandJoinListContainer));
